import { createStore } from "vuex";
//import AuthService from "./service/auth/auth_service";
//import Token from "./utilities/jwt/Token.js";

export default createStore({
  state() {
    return {

      views: {
        paciente: {
          dialogPacienteView: false,
        }

      },
    };
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
});
// getters: {
//   getUserLogged(state) {
//     //let authService = new AuthService();
//     state.userLogged = null;
//     let token = new Token().jwtDecode();
//     token = [
//       {
//         nome: token.name,
//         id: token.code,
//         services: token.services,
//         email: token.user_name,
//         authorities: token.authorities,
//       },
//     ];
//     return (state.userLogged = token[0]);
//   },
//
// },
